export const TokenTransactionMap = {
  GET_ALL_TOKEN_TXN_START: "GET_ALL_TOKEN_TXN_START",
  GET_ALL_TOKEN_TXN_SUCCESS: "GET_ALL_TOKEN_TXN_SUCCESS",
  GET_ALL_TOKEN_TXN_ERROR: "GET_ALL_TOKEN_TXN_ERROR",
  ADD_TOKEN_TXN_START: "ADD_TOKEN_TXN_START",
  ADD_TOKEN_TXN_SUCCESS: "ADD_TOKEN_TXN_SUCCESS",
  ADD_TOKEN_TXN_ERROR: "ADD_TOKEN_TXN_ERROR",
  // SELECT_USER_DETAILS: "SELECT_USER_DETAILS",
  // COUNTRY_FILTERS: "COUNTRY_FILTERS",
  APPLY_FILTERS: "APPLY_FILTERS",
  SEARCH_TEXT_CHANGE: "SEARCH_TEXT_CHANGE",
  SELECT_TEXT_CHANGE: "SELECT_TEXT_CHANGE",
  // SELECT_TEXT_CHANGE: "SELECT_TEXT_CHANGE",
  REFRESH_TOKEN_TXN_LIST: "REFRESH_TOKEN_TXN_LIST",
  SET_TOKEN_TXN_BATCH_NUMBER: "SET_TOKEN_TXN_BATCH_NUMBER",
  // SELECT_TOKEN_TXN_DETAILS: "SELECT_TOKEN_TXN_DETAILS",
  // GET_ALL_TEMPLATES_START: "GET_ALL_TEMPLATES_START",
  // GET_ALL_TEMPLATES_SUCCESS: "GET_ALL_TEMPLATES_SUCCESS",
  // GET_ALL_TEMPLATES_ERROR: "GET_ALL_TEMPLATES_ERROR",
  UPDATE_TOKEN_TXN_START: "UPDATE_TOKEN_TXN_START",
  UPDATE_TOKEN_TXN_SUCCESS: "UPDATE_TOKEN_TXN_SUCCESS",
  UPDATE_TOKEN_TXN_ERROR: "UPDATE_TOKEN_TXN_ERROR",
  // DELETE_TOKEN_TXN_START: "DELETE_TOKEN_TXN_START",
  // DELETE_TOKEN_TXN_SUCCESS: "DELETE_TOKEN_TXN_SUCCESS",
  // DELETE_TOKEN_TXN_ERROR: "DELETE_TOKEN_TXN_ERROR",
  GET_TOKEN_TRANSACTION_START: "GET_TOKEN_TRANSACTION_START",
  GET_TOKEN_TRANSACTION_SUCCESS: "GET_TOKEN_TRANSACTION_SUCCESS",
  GET_TOKEN_TRANSACTION_ERROR: "GET_TOKEN_TRANSACTION_ERROR",
  SET_TO_DATE_CHANGES: "SET_TO_DATE_CHANGES",
  SET_FROM_DATE_CHANGES: "SET_FROM_DATE_CHANGES",
  RESET_FILTERS: "RESET_FILTERS",
};

export const TokenTransactionActions = {
  getAllTokenTransactionStart: (data) => ({
    type: TokenTransactionMap.GET_ALL_TOKEN_TXN_START,
    payload: data,
  }),
  getAllTokenTransactionSuccess: (data) => ({
    type: TokenTransactionMap.GET_ALL_TOKEN_TXN_SUCCESS,
    payload: data,
  }),
  getAllTokenTransactionError: (errors) => ({
    type: TokenTransactionMap.GET_ALL_TOKEN_TXN_ERROR,
    payload: { errors },
  }),
  getTokenTransactionStart: (data) => ({
    type: TokenTransactionMap.GET_TOKEN_TRANSACTION_START,
    payload: data,
  }),
  getTokenTransactionSuccess: (data) => ({
    type: TokenTransactionMap.GET_TOKEN_TRANSACTION_SUCCESS,
    payload: data,
  }),
  getTokenTransactionError: (errors) => ({
    type: TokenTransactionMap.GET_TOKEN_TRANSACTION_ERROR,
    payload: { errors },
  }),
  // deleteTokenTransactionStart: (data) => ({
  //   type: TokenTransactionMap.DELETE_TOKEN_TXN_START,
  //   payload: data,
  // }),
  // deleteTokenTransactionSuccess: (data) => ({
  //   type: TokenTransactionMap.DELETE_TOKEN_TXN_SUCCESS,
  //   payload: data,
  // }),
  // deleteTokenTransactionError: (errors) => ({
  //   type: TokenTransactionMap.DELETE_TOKEN_TXN_ERROR,
  //   payload: { errors },
  // }),
  addTokenTransactionStart: (data) => ({
    type: TokenTransactionMap.ADD_TOKEN_TXN_START,
    payload: data,
  }),
  addTokenTransactionSuccess: (data) => ({
    type: TokenTransactionMap.ADD_TOKEN_TXN_SUCCESS,
    payload: data,
  }),
  addTokenTransactionError: (errors) => ({
    type: TokenTransactionMap.ADD_TOKEN_TXN_ERROR,
    payload: { errors },
  }),
  updateTokenTransactionStart: (data) => ({
    type: TokenTransactionMap.UPDATE_TOKEN_TXN_START,
    payload: data,
  }),
  updateTokenTransactionSuccess: (data) => ({
    type: TokenTransactionMap.UPDATE_TOKEN_TXN_SUCCESS,
    payload: data,
  }),
  updateTokenTransactionError: (errors) => ({
    type: TokenTransactionMap.UPDATE_TOKEN_TXN_ERROR,
    payload: { errors },
  }),
  // getTokenTransactionTemplateStart: (data) => ({
  //   type: TokenTransactionMap.GET_ALL_TEMPLATES_START,
  //   payload: data,
  // }),
  // getTokenTransactionTemplateSuccess: (data) => ({
  //   type: TokenTransactionMap.GET_ALL_TEMPLATES_SUCCESS,
  //   payload: data,
  // }),
  // getTokenTransactionTemplateError: (errors) => ({
  //   type: TokenTransactionMap.GET_ALL_TEMPLATES_ERROR,
  //   payload: { errors },
  // }),
  applyFilters: (data) => ({
    type: TokenTransactionMap.APPLY_FILTERS,
    payload: data,
  }),
  refreshTokenTransactionList: () => ({
    type: TokenTransactionMap.REFRESH_TOKEN_TXN_LIST,
  }),
  searchTextChange: (data) => ({
    type: TokenTransactionMap.SEARCH_TEXT_CHANGE,
    payload: data,
  }),

  selectTextChange: (updatedFields) => ({
    type: TokenTransactionMap.SELECT_TEXT_CHANGE,
    payload: updatedFields,
  }),
  // selectChange: (data) => ({
  //   type: TokenTransactionMap.SELECT_TEXT_CHANGE,
  //   payload: data,
  // }),
  // setSelectedTokenTransaction: (data) => ({
  //   type: TokenTransactionMap.SELECT_TOKEN_TXN_DETAILS,
  //   payload: data,
  // }),
  setVirtualTokenBatchNumber: (data) => ({
    type: TokenTransactionMap.SET_TOKEN_TXN_BATCH_NUMBER,
    payload: data,
  }),
  toDateChanges: (data) => ({
    type: TokenTransactionMap.SET_TO_DATE_CHANGES,
    payload: data,
  }),
  fromDateChanges: (data) => ({
    type: TokenTransactionMap.SET_FROM_DATE_CHANGES,
    payload: data,
  }),
  resetFilters: (data) => ({
    type: TokenTransactionMap.RESET_FILTERS,
    payload: data,
  }),
};
